'use strict';

exports.__esModule = true;
exports.BLOCK_SIZE = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.getEtag = getEtag;

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BLOCK_SIZE = exports.BLOCK_SIZE = 4 * 1024 * 1024;
var crypto = require('crypto');
var BYTE_LOW_4 = 0x16;
var BYTE_OVER_4 = 0x96;

function blockCount(file) {
    var count = Math.ceil(file.size / BLOCK_SIZE);
    return count;
}

/**
 * 不分块的情况计算文件sha1值
 */
function encodeFileSha1(file) {
    return new _promise2["default"](function (resolve) {
        file.arrayBuffer().then(function (arrayBuffer) {
            var buf = new Buffer(arrayBuffer.byteLength);
            var view = new Uint8Array(arrayBuffer);
            for (var i = 0; i < buf.length; ++i) {
                buf[i] = view[i];
            }
            var sha = crypto.createHash('sha1');
            sha.update(buf);
            var shaBuffer = sha.digest();
            resolve(shaBuffer);
        });
    });
}

/**
 * 计算每块的sha1值
 */
function encodeSha1(chunk, sha1Buffers, index) {
    return new _promise2["default"](function (resolve) {
        chunk.arrayBuffer().then(function (arrayBuffer) {
            var buf = new Buffer(arrayBuffer.byteLength);
            var view = new Uint8Array(arrayBuffer);
            for (var i = 0; i < buf.length; ++i) {
                buf[i] = view[i];
            }
            var sha = crypto.createHash('sha1');
            sha.update(buf);
            var shaBuffer = sha.digest();
            sha1Buffers[index] = shaBuffer;
            resolve();
        });
    });
}

function multipartSha1(sha1Strings) {
    var rec = Buffer.concat(sha1Strings);
    var sha1 = crypto.createHash('sha1');
    sha1.update(rec);
    return sha1.digest();
}

function getEtag(file) {
    return new _promise2["default"](function (resolve) {
        var count = blockCount(file);
        var etagHash = "";
        if (count <= 1) {
            var promise = encodeFileSha1(file);
            promise.then(function (shaBuffer) {
                var clcBuffer = new Buffer(shaBuffer.length + 1);
                clcBuffer[0] = BYTE_LOW_4;
                for (var i = 0; i < shaBuffer.length; i++) {
                    clcBuffer[i + 1] = shaBuffer[i];
                }
                var etagHash = (0, _util.URLSafeEncode)(clcBuffer.toString('base64'));
                resolve(etagHash);
            });
        } else {
            var sha1Buffers = new Array(count);
            var promises = [];
            for (var i = 0; i < count; i++) {
                var chunk = file.slice(BLOCK_SIZE * i, i === count - 1 ? file.size : BLOCK_SIZE * (i + 1));
                promises.push(encodeSha1(chunk, sha1Buffers, i));
            }
            // 计算完所有块的sha1后才能继续进行
            _promise2["default"].all(promises).then(function () {
                var ret = multipartSha1(sha1Buffers);
                var clcBuffer = new Buffer(ret.length + 1);
                clcBuffer[0] = BYTE_OVER_4;
                for (var _i = 0; _i < ret.length; _i++) {
                    clcBuffer[_i + 1] = ret[_i];
                }
                var etagHash = (0, _util.URLSafeEncode)(clcBuffer.toString('base64'));
                resolve(etagHash);
            });
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/etagUtil.js
// module id = 200
// module chunks = 0